import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is fresh for 30s — no refetch if another component mounts
      staleTime: 30_000,
      // Keep unused data in cache for 10 minutes (helps back/forward nav)
      gcTime: 10 * 60_000,
      // Retry once on failure (2 total attempts)
      retry: 1,
      // Refetch when user returns to tab (catches stale data)
      refetchOnWindowFocus: true,
      // Refetch stale queries when network reconnects
      refetchOnReconnect: 'always',
    },
    mutations: {
      // Retry mutations once (network glitches)
      retry: 1,
    },
  },
});
